import React from 'react';
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';
import groupedUnits from './units';

interface IDatasetUnitSelectorProps {
    className: string;
    value: string;
    name?: string;
    onChange: (e: DropdownChangeParams) => void;
}

const DatasetUnitSelector = ({ className, value, name, onChange }: IDatasetUnitSelectorProps) => {

    return <Dropdown
        className={className}
        value={value}
        name={name}
        onChange={onChange}
        options={groupedUnits}
        optionLabel='label'
        optionGroupLabel='label'
        optionGroupChildren='items'
        filter
        editable />;
};

export default DatasetUnitSelector;
